import clsx from 'clsx'
import { Loader } from '@/components/Loader'
import { ButtonBase } from '../ButtonBase'
import { IButtonProps } from '../types'
import styles from './styles.module.scss'

const ButtonPrimary = ({ children, isLoading, className, ...props }: IButtonProps) => {
  return (
    <ButtonBase
      data-testid="mui-button-primary"
      className={clsx(styles.primary, className)}
      isLoading={isLoading}
      {...props}
    >
      {isLoading && <Loader className={styles.loader} />}
      {children}
    </ButtonBase>
  )
}

export default ButtonPrimary
